import { cva } from "class-variance-authority";

// Every item sits in the same single grid cell, so the root is as big as its biggest item and a swap never resizes it.
export const rootStyles = cva("inline-grid shrink-0 grid-cols-1 grid-rows-1 place-items-center");

// Items fade and shrink out, and `invisible` lands once the fade-out ends, taking the item out of the accessibility
// tree. The transition sits on the item, not the icon: `tailwindcss-animate` makes `duration-*` set
// `animation-duration` too, which would speed up an animated icon such as a spinner.
export const itemStyles = cva(
  "col-start-1 row-start-1 flex items-center justify-center transition-[opacity,scale,visibility] duration-200 ease-out",
  {
    variants: {
      active: {
        true: "",
        false: "invisible scale-50 opacity-0",
      },
    },
  }
);
